import * as React from 'react';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';
import { getRandom } from '../../funcs';
import { ListItem, styled, Typography } from '@mui/material';



export default function TextList({latest,setOpenSearch,openSearch,setSearchTitle}) {
const [isExpanded, setIsExpanded] = React.useState("0")
  
  const CollapsibleText = styled(Typography)(({ expanded=false }) => ({
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    color: '#666' ,
    marginBottom:10,
    WebkitLineClamp: expanded=="1" ? 'none' : 10, // 展开时不限制行数
  }))

  const toggleExpanded = () => {
    setIsExpanded((prev) => {
      if(prev == "1")
        return "0"
      if(prev == "0")
        return "1"
    }); // 切换展开状态
  };
  const handleSearchDialog = (searchTitle)=>{
    setSearchTitle(searchTitle)
    setOpenSearch(true)
  }

  return (
    <Paper elevation={3} style={{ maripadding: '16px', maxWidth: '95%',margin:"auto"}}>
      <List 
        style={{marginTop:10}}
        onClick={()=>{
            handleSearchDialog(latest.title)
        }}
    >
          <ListItem style={{ paddingTop:0,paddingBottom:0 }}>
            <ListItemText 
              primary={` ${latest.title}系列（${latest.total}集）`} 
            />
          </ListItem>
          <ListItem style={{ }}>
            <CollapsibleText variant="body2" expanded={isExpanded} onClick={toggleExpanded}>
              系列内容：{latest.content}
            </CollapsibleText>
          </ListItem>
          <ListItem style={{ paddingTop:0,paddingBottom:0 }}>
            <Typography style={{
                fontSize:12,
                color:"#666"
            }}>
                系列类型：{latest.remark}
            </Typography>
          </ListItem>
      </List>
    </Paper>
  );
}
